import { render, staticRenderFns } from "./waiting-screen.vue?vue&type=template&id=af643962&scoped=true&"
import script from "./waiting-screen.vue?vue&type=script&lang=js&"
export * from "./waiting-screen.vue?vue&type=script&lang=js&"
import style0 from "./waiting-screen.vue?vue&type=style&index=0&id=af643962&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af643962",
  null
  
)

export default component.exports